import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/react/react/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import { ComponentStatuses } from '../src/component-statuses';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`See the `}<a parentName="p" {...{
        "href": "https://primer.style/contribute/component-lifecycle"
      }}>{`component lifecycle`}</a>{` for more information about each status.`}</p>
    <ComponentStatuses mdxType="ComponentStatuses" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      